import React, { useState } from 'react';
import { css } from '@emotion/react';
import Image from 'gatsby-plugin-sanity-image';

export default function FadeGallery({ images, className }) {
  const [current, setCurrent] = useState(0);

  return (
    <div
      className={`type--body ${className}`}
    >
      <div
        css={css`
          display: grid;
          grid-template-columns: 1;
          gap: var(--gutter);
          position: relative;
        `}
      >
        {images.length > 0 && images
          .map((image, i) => (
            <div
              key={i}
              css={css`
                grid-row-start: 1;
                grid-column-start: 1;
                grid-column-end: 1;
                line-height: 0;
                opacity: ${(current === i) ? 1 : 0};
                transition: opacity 0.6s var(--curve);
                will-change: opacity;
              `}
            >
              <img
                src={image.image?.asset.gatsbyImageData.images.fallback.src}
                css={css`
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                `}
              />
            </div>
          ))
        }
      </div>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          margin-top: 2rem;
        `}
      >
        <div
          className="type--extra-small"
        >{current + 1}/{images.length}</div>
        {images.length > 1 && <div
          css={css`
            line-height: 0;
          `}
        >
          <img
            css={css`
              padding: 0 1rem;
              cursor: ${(current === 0) ? 'auto' : 'pointer'};
              opacity: ${(current === 0) ? 0.3 : 1};
              transition: opacity 0.6s var(--curve);
            `}
            src={`/images/arrow-left--dark.svg`}
            alt="Previous"
            onClick={(e) => {if (current > 0) setCurrent(current - 1); e.stopPropagation();} }
          />
          <img
            css={css`
              padding: 0 1rem;
              cursor: ${(current === images.length - 1) ? 'auto' : 'pointer'};
              opacity: ${(current === images.length - 1) ? 0.3 : 1};
              transition: opacity 0.6s var(--curve);
            `}
            src={`/images/arrow-right--dark.svg`}
            alt="Next"
            onClick={(e) => {if (current < images.length - 1) setCurrent(current + 1); e.stopPropagation();} }
          />
        </div>}
      </div>
      <div
        css={css`
          display: grid;
          grid-template-columns: 1;
          position: relative;
          margin-top: 3rem;
        `}
      >
        {images.length > 0 && images
          .map((image, i) => (
            <div
              key={i}
              css={css`
                grid-row-start: 1;
                grid-column-start: 1;
                grid-column-end: 1;
                opacity: ${(i === current) ? 1 : 0};
                transition: opacity 0.6s var(--curve);
                will-change: opacity;
              `}
            >
              {image.caption}
            </div>
          ))
        }
      </div>
    </div>
  );
};
